import React from 'react';

import { BsXCircle } from 'react-icons/bs';

function ErrorPane({ heading = 'Something went wrong', subheaading }) {
  return (
    <div className="container-fluid py-4 py-sm-5">
      <div className="row p-3 shadow-sm rounded bg-white">
        <div className="col">
          <div className="row my-3">
            <div className="col-auto">
              <BsXCircle style={{ fontSize: '3em' }} className="text-secondary" />
            </div>
            <div className="col">
              <h2>{heading}</h2>
              <p className="mb-0">{subheaading}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export function PageNotFound() {
  return <ErrorPane heading="Page Not Found" subheaading="Please check the URL or select an option from the menu." />;
}

export function NotFound() {
  return <ErrorPane heading="Not Found" />;
}

export default ErrorPane;
